import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

type WrapProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof container> & {
    height?: 'fill'
    reduced?: boolean
    sidebar?: React.ReactNode
    mobilePadding?: boolean
    toggle?: boolean
    id?: string
  }

const container = cva('container', {
  variants: {
    reduced: {
      true: 'max-w-[1088px]',
    },
    height: {
      fill: 'h-full',
    },
    mobilePadding: {
      true: 'px-3 md:px-5',
      false: 'px-0 md:px-5',
    },
  },
})

export default function Container({
  children,
  className,
  height,
  reduced,
  sidebar,
  mobilePadding = true,
  toggle = true,
  id,
}: WrapProps) {
  return (
    <div className={cn(container({ height, reduced, mobilePadding }))} id={id}>
      <div className={className}>
        {sidebar ? (
          <div
            className={cn(
              'relative flex flex-col justify-center pb-12 md:flex-row md:gap-5 md:pt-8 lg:gap-8',
              toggle ? 'gap-0' : 'gap-5',
            )}
          >
            <div
              className={cn(
                'z-10 order-2 flex w-full flex-col gap-4 md:order-1 md:w-2/3 md:px-0 md:hover:z-20 lg:w-full lg:max-w-[640px]',
                mobilePadding ? 'px-0' : 'px-3',
              )}
            >
              {children}
            </div>
            <aside className="sticky top-20 z-20 order-1 col-span-1 flex h-fit w-full flex-col gap-4 md:top-24 md:z-10 md:order-2 md:w-1/3 md:hover:z-20 lg:w-full lg:max-w-[376px] lg:shrink-0">
              {sidebar}
            </aside>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  )
}
